<div
  class="background"
  [ngClass]="{ background_open: state.open }"
  (click)="close()"
></div>

<div
  class="brn-generic-popup"
  [ngClass]="{ 'brn-generic-popup_open': state.open }"
>
  <ng-container *cdkPortalOutlet></ng-container>
</div>
